import { gql } from "@/__generated__/gql";

export const MAJORS = gql(`
  query Major(
    $first: Int
    $after: String
  ) {
    majors(first: $first, after: $after) {
      edges {
        node {
          name
          id
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
`);
